import React from 'react'

import { HeadlineBlock } from 'components/dataDisplay'
import { WidthContainer } from 'components/layout'
import FaqContent from 'compositions/faq/FaqContent/FaqContent'

import messages from './messages'


type FaqSectionProps = {
  className?: string
}

const FaqSection: React.FC<FaqSectionProps> = ({ className }) => {
  return (
    <WidthContainer className={className} size={944}>
      <HeadlineBlock
        supTitle={messages.supTitle}
        title={messages.title}
      />
      <FaqContent />
    </WidthContainer>
  )
}

export default FaqSection
